export default __webpack_public_path__ + "static/media/Group8864.2cc2354b.svg";